import * as React from 'react';

import Dialog from 'components/Dialog';
import EventTracking from 'lib/EventTracking';
import LinkDeviceVerificationCodeBox from 'user/components/LinkDeviceVerificationCodeBox';

type Props = {
  deviceName: string;
  onDone: () => void;
  onRequestHide: () => void;
  viewEventKey?: string;
  clickEventKey?: string;
  deviceType?: string;
};

export default function LinkDeviceVerificationCodeBoxDialog(props: Props) {
  React.useEffect(() => {
    if (props.viewEventKey) {
      EventTracking.trackKey(props.viewEventKey);
    }
  }, [props.viewEventKey]);

  return (
    <Dialog {...props} size="small" box>
      <LinkDeviceVerificationCodeBox
        showFooter={false}
        submittedAddress={props.deviceName}
        deviceType={props.deviceType || "email"}
        onDone={() => {
          props.onRequestHide();
          props.onDone();
        }}
        data-test="enter-verification-code-dialog"
        clickEventKey={props.clickEventKey}
      />
    </Dialog>
  );
}
